import { DbStatus } from '../enums/db-status.enum';
import { extractDateTimeStamp } from '../utils/date-timestamp-extraction';

export interface Notification {
  id?: string;
  backfilled?: boolean;
  category?: string;
  createdAt?: Date | null;
  dbStatus?: DbStatus;
  eventType?: string;
  messageIds?: string[];
  metadata?: {
    horseId?: string;
    [key: string]: any;
  };
  resourceId?: string;
  resourceType?: string;
  updatedAt?: Date | null;
  userId?: string;
  userViewedAt?: Date | null;
  viewStatus?: boolean;
  title?: string;
  body?: string;
  active?: boolean;
  [key: string]: any;
}

export class NotificationClass implements Notification {
  id?: string;
  backfilled?: boolean;
  category?: string;
  createdAt?: Date | null;
  dbStatus?: DbStatus;
  eventType?: string;
  messageIds?: string[];
  metadata?: {
    horseId?: string;
    [key: string]: any;
  };
  resourceId?: string;
  resourceType?: string;
  updatedAt?: Date | null;
  userId?: string;
  userViewedAt?: Date | null;
  viewStatus?: boolean;
  title?: string;
  body?: string;
  active?: boolean;
  [key: string]: any;

  constructor(o: any = {}) {
    this.id = o['id'];
    this.backfilled = o['backfilled'];
    this.category = o['category'];
    this.dbStatus = o['dbStatus'];
    this.eventType = o['eventType'];
    this.messageIds = o['messageIds'];
    this.metadata = o['metadata'];
    this.resourceId = o['resourceId'];
    this.resourceType = o['resourceType'];
    this.userId = o['userId'];
    this.viewStatus = o['viewStatus'];
    this.title = o['title'];
    this.body = o['body'];
    this.active = o['active'];
    this.createdAt = extractDateTimeStamp(o['createdAt'], this.id);
    this.updatedAt = extractDateTimeStamp(o['updatedAt'], this.id);
    this.userViewedAt = extractDateTimeStamp(o['userViewedAt'], this.id);
  }
}
